import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'pgh-generic-content-page',
  templateUrl: './generic-content-page.component.html',
  styleUrl: './generic-content-page.component.scss'
})
export class GenericContentPageComponent implements OnInit {
  contentKey: string;
  titleKey: string;
  bodyKey: string;
  pageTitle: string = '';
  contentNotFound: boolean = false;
  constructor(
    private resourceService: ADPResourceService,
    private activatedRoute: ActivatedRoute,
    public title: Title,
  ) { }
  ngOnInit(): void {
    this.contentKey = this.activatedRoute?.snapshot?.params?.key;
      if (this.resourceService.getPortalLabel("GenericContent_" + this.contentKey + "_Title") == null || this.resourceService.getPortalLabel("GenericContent_" + this.contentKey + "_Body") == null) {
        this.contentNotFound = true;
        this.pageTitle = this.resourceService.getPortalLabel("GenericContent_Default_PageTitle").Value;
      } else {
        this.titleKey = "GenericContent_" + this.contentKey + "_Title";
        this.bodyKey = "GenericContent_" + this.contentKey + "_Body";
        this.pageTitle = this.resourceService.getPortalLabel("GenericContent_" + this.contentKey + "_PageTitle")?.Value;
      }
    let originalTitle = this.title.getTitle();
    this.title.setTitle(this.pageTitle + ' | ' + originalTitle);
  }
}
